import Component from "../Component";
import SignIn from "../SignIn";
import Page from "~/pages/Page";
import {domSelectors} from "~/globals";
import $ from "jquery"; 
import "~/jquery-validate.js";
import {getApi, login, clearBackendSession, handleError, type UserInfo} from "~/auth";
import {getParameterValue, isNullish,returnUrl,  navigateTo} from "~/utils";
import * as bootstrap from "bootstrap";
import * as bootbox from "bootbox";
import UI from "~/ui";


class SignInModal extends Component {
    constructor() {
        super(domSelectors.SignInModal, true);
    }

    private _loginCallbacks: ((user: UserInfo) => Promise<void>)[] = [];

    private _signIn!: SignIn;
    
    public onLogin(value: (user: UserInfo) => Promise<void>) {
        this._signIn!.onLogin(value);
    }

    activate(): Promise<void> {
        const that = this;
        this._signIn = new SignIn(this.currentPage)
        
        let _ = that._signIn.activate();
        
        $(this.domElement).modal({
            keyboard: false
        });

        // const handleEnterKeyup = (e: any, $otherField: JQuery, $submit: JQuery) => {
        //     if (e.key === "Enter" && $otherField.val() != "")
        //         $submit.trigger("click");
        //     else
        //         that.clearMessage();
        // }
        // const handleSubmit = async ($passwordInput: JQuery, $emailInput: JQuery, $passwordError: JQuery, $emailError: JQuery, $form: JQuery) => {
        //     const isPasswordValid = $passwordInput.val() != null && $passwordInput.val() != '';
        //     const isEmailValid = $emailInput.val() != null && $emailInput.val() != '';
        //
        //     $passwordError.toggle(!isPasswordValid);
        //     $emailError.toggle(!isEmailValid);
        //
        //     if (isPasswordValid && isEmailValid) {
        //         const username = $emailInput.val() as string;
        //         const password = $passwordInput.val() as string;
        //         that.currentPage.spinner.spin().then(() => {
        //         });
        //         try {
        //             let user = await login(username, password);
        //
        //             that._loginCallbacks.forEach(callback => {
        //                 callback(user);
        //             })
        //
        //         } catch (err) {
        //             let errHtml = handleError(err);
        //             that.showMessage(errHtml);
        //         } finally {
        //             that.currentPage.spinner.stop();
        //         }
        //     }
        // };
        //
        // $emailInput.on('keyup', (e) => {
        //     handleEnterKeyup(e, $("#password-input-login"), $("a#submitLogin")); 
        // });
        // $passwordInput.on('keyup', (e) => {
        //     handleEnterKeyup(e, $("#email-input-login"), $("a#submitLogin"));
        // });
        // $emailInputMobile.on('keyup', (e)=>  {
        //     handleEnterKeyup(e, $("#password-input-login-mobile"), $("a#submitLoginMobile"));
        // });
        // $passwordInputMobile.on('keyup', (e)=>  {
        //     handleEnterKeyup(e, $("#email-input-login-mobile"), $("a#submitLoginMobile"));
        // });

        // $("a#submitLogin").on('click', e => {
        //     e.preventDefault();
        //     e.stopImmediatePropagation();
        //     handleSubmit(
        //         $("#password-input-login"),
        //         $("#email-input-login"),
        //         $("#password-error"),
        //         $("#email-error"),
        //         $("#form-login")
        //     );
        //     return false;
        // });

        // $("a#submitLoginMobile").on('click', e => {
        //     e.preventDefault();
        //     handleSubmit(
        //         $("#password-input-login-mobile"),
        //         $("#email-input-login-mobile"),
        //         $("#password-error-mobile"),
        //         $("#email-error-mobile"),
        //         $("#form-login-mobile")
        //     );
        // });
        // const setupFormValidation = ($form: JQuery, $emailInput: JQuery, $passwordInput: JQuery) => {
        //     $form.validate({
        //         submitHandler: async () => {
        //
        //         }
        //     });
        // };
        //
        // setupFormValidation(
        //     $("#form-login"),
        //     $emailInput,
        //     $passwordInput);
        //
        // setupFormValidation(
        //     $("#form-login-mobile"),
        //     $emailInputMobile,
        //     $passwordInputMobile);


        //eventuali errori di login di ritorno in querystring dai providers esterni
        let error = getParameterValue("error");

        if (!isNullish(error)) {
            this._signIn!.showMessage(error!);
            this.show();
        }

        $("a.close").on('click', e => {
            e.preventDefault();
            this._signIn!.clearMessage();
            returnUrl("");
            this.hide();
        });

        $("#btnSignIn").on('click', async (e) => {
            const auth = getApi();
            const userInfo = auth.getCached("userInfo");
            const beUser : string = Page.current.backendSessionUser;
            let clearSession : boolean = false;
            
            
            if (!userInfo || !userInfo.isAuthenticated) {
                getApi().clearAllCached(true);
                await clearBackendSession();
               
                this.show();
            } else {
                
            }
            if ($("body").data("onlogin-return") == true)
                returnUrl(window.location.pathname + window.location.search);
            else
                returnUrl("");
        });

        return Promise.resolve();
    }

    public show(): Component {
        $(this.domElement).modal('show');
        $("div.messageText")
            .html("")
            .addClass("fade");
        
      
        
        return this;
    }

    public hide(): Component {
        if (this.domElement) {
            $(this.domElement).modal('hide');
        }
        return this;
    }

    // private clearMessage(): void {
    //     $(this.domElement)
    //         .find('div.messageText')
    //         .html("")
    //         .addClass("d-none")
    //         .removeClass("show");
    // }
    //
    // private showMessage(message: string, type?: string) {
    //     let $msg = $(this.domElement)
    //         .find('div.messageText');
    //
    //     $msg.html(message)
    //         .removeClass("d-none")
    //         .removeClass("fade");
    //
    //     if (type != undefined) {
    //         $msg.addClass(type);
    //     }
    // }


}

export default SignInModal;